// @flow
import React from 'react'
import Picture from '../picture'
import Animation3 from '../animation3'
import Animation9 from '../animation9'
import { Animation22 } from  '../animation22'
import Animation39 from '../animation39'
import './styles.scss'

export class Grid extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
    }
    this.updateSizes = this.updateSizes.bind(this)
  }

  updateSizes() {
    this.setState({
      isMobile: window.innerWidth < 711
    })
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateSizes)
    this.updateSizes()
  }

  render() {
    return <div className='grid'>
          <Picture src='1.gif' className='double left' />
          <Picture no={2} className='double right' />
          <Animation3 />
          <Picture no={4} />
          <Picture no={5} className='double right' />
          <Picture src='6.gif' className='double left' />
          <Picture src='7.gif' />
          <Picture no={8} />
          <Animation9 className='double left' />
          <Picture src='10.gif' className='double right' />

          <Picture no={11} />
          <Picture src='12.gif' />
          <Picture no={13} className='double right' />
          <Picture src='14.gif' className='double left' />
          <Picture no={15} className='double right' />
          <Picture no={16} className='fourer left p16' />
          <Picture src='17.gif' className='double right p17' />
          <Picture no={19} />
          <Picture no={20} />
          <Picture no={21} />
          <Animation22 />

          <Picture no={23} />
          <Picture no={24} />
          <Picture no={25} />
          <Picture no={26} />
          <Picture src='27.gif' className='double left' />
          <Picture src='28.gif' />
          <Picture src='29.gif' />
          <Picture no={30} />
          <Picture no={31} />
          <Picture no={32} />
          <Picture src='33.gif' />
          <Picture src='34.gif' />
          <Picture no={35} />
          <Picture no={36} className='double right' />
          <Picture no={37} />
          <Picture no={38} />
          <Animation39 />
          <Picture no={40} />
    </div>
  }
}
